import React from "react";
import PropTypes from "prop-types";

const SendingPollLock = props => {
  const { show } = props;
  return (
    <div className={show ? "modal is-active" : "modal"}>
      <div className="modal-background" />
      <div className="modal-content">
        <div className="box">
          <div className="content">
            <h3>Poczekaj na zakończenie operacji...</h3>
            <div>
              W tej chwili zapisujemy dane. Prosimy o chwilę cierpliwości.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SendingPollLock.propTypes = {
  show: PropTypes.bool.isRequired
};
export default SendingPollLock;



// WEBPACK FOOTER //
// ./src/components/poll/SavingPollLock.js